<template>
  <v-container fluid px-0>
    <sec-hero-hears></sec-hero-hears>
    <sec-diagonal v-model="this.$diagonal.top"></sec-diagonal>
    <sec-product-summary-hears></sec-product-summary-hears>
    <sec-diagonal v-model="this.$diagonal.bottom"></sec-diagonal>
    <sec-use-cases-hears></sec-use-cases-hears>
    <pricing-hears :user="this.user" bgclass="darkbg" showtitle="false"></pricing-hears>
    <!-- <sec-diagonal v-model="this.$diagonal.top"></sec-diagonal>     -->
    <sec-faq-hears></sec-faq-hears>
    <sec-diagonal v-model="this.$diagonal.top"></sec-diagonal>
    <sec-create-account></sec-create-account>
    <sec-products-summary></sec-products-summary>
    <!-- <sec-diagonal v-model="this.$diagonal.bottom"></sec-diagonal> -->
    <!-- <public-app-layout-footer></public-app-layout-footer> -->
  </v-container>
</template>

<script>
import SecHeroHears from '@/components/pages/public/landings/SecHeroHears';
import SecUseCasesHears from '@/components/pages/public/landings/SecUseCasesHears';
import SecProductSummaryHears from '@/components/pages/public/landings/SecProductSummaryHears';
import PricingHears from '@/components/pages/public/pricing/PricingHears';
import SecFaqHears from '@/components/pages/public/landings/SecFaqHears';
import SecCreateAccount from '@/components/pages/public/SecCreateAccount';
import SecProductsSummary from '@/components/pages/public/SecProductsSummary';
import SecDiagonal from '@/components/pages/public/SecDiagonal';

// import PublicAppLayoutFooter from '@/components/layouts/PublicAppLayoutFooter';

export default {
  name: "LandingPatrowlHears",
  props: ['user'],
  components: {
    SecHeroHears,
    SecUseCasesHears,
    SecProductSummaryHears,
    PricingHears,
    SecFaqHears,
    SecCreateAccount,
    SecProductsSummary,
    SecDiagonal,
    // PublicAppLayoutFooter
  },
  metaInfo: {
    title: 'PatrowlHears.io',
    meta: [
      {name: 'keywords', content: 'PatrowlHears, Vulnerability Intelligence, Vulnerability Management, SecOps, Threat Intelligence, Scoring, Rating, Cyber-Rating, Cyber-Scoring, Exploit, PoC, Feeds, SaaS'},
      {name: 'description', content: 'Real-time vulnerability and threat intelligence platform, on steroids. Access a comprehensive and continuously updated vulnerability database scored and enriched with exploit and threat news information. Metadata are collected and qualified by security experts from public OSINT and private feeds'},
      // OpenGraph data (Most widely used)
      {property: 'og:title', content: 'PatrowlHears.io Website'},
      {property: 'og:site_name', content: 'PatrowlHears.io'},
      {property: 'og:type', content: 'website'},
      {property: 'og:url', content: 'https://patrowlhears.io'},
      {property: 'og:image', content: 'https://patrowlhears.io/static/img/patrowlhears-hero.ab779480.png'},
      // Often the same as your meta description, but not always.
      {property: 'og:description', content: 'Real-time vulnerability and threat intelligence platform, on steroids. Access a comprehensive and continuously updated vulnerability database scored and enriched with exploit and threat news information. Metadata are collected and qualified by security experts from public OSINT and private feeds'},

      // Twitter card
      {name: 'twitter:card', content: 'summary'},
      {name: 'twitter:site', content: 'https://patrowlhears.io'},
      {name: 'twitter:title', content: 'PatrowlHears - Vulnerability Intelligence Center'},
      {name: 'twitter:description', content: 'Real-time vulnerability and threat intelligence platform, on steroids. Access a comprehensive and continuously updated vulnerability database scored and enriched with exploit and threat news information. Metadata are collected and qualified by security experts from public OSINT and private feeds'},
      // Your twitter handle, if you have one.
      {name: 'twitter:creator', content: '@patrowl_io'},
      {name: 'twitter:image:src', content: 'https://patrowlhears.io/static/img/patrowlhears-hero.ab779480.png'},

      // Google / Schema.org markup:
      {itemprop: 'name', content: 'PatrowlHears - Vulnerability Intelligence Center'},
      {itemprop: 'description', content: 'Real-time vulnerability and threat intelligence platform, on steroids. Access a comprehensive and continuously updated vulnerability database scored and enriched with exploit and threat news information. Metadata are collected and qualified by security experts from public OSINT and private feeds'},
      {itemprop: 'image', content: 'https://patrowlhears.io/static/img/patrowlhears-hero.ab779480.png'},

      {name: 'robots', content: 'index,follow'},
    ]
  },
};
</script>

<style>
</style>
